import React from 'react';
import { Tooltip, IconButton } from '@barracuda-internal/bds-core-v2';
import Download from '@mui/icons-material/Download';
import Refresh from '@mui/icons-material/Refresh';
import { Box } from '@material-ui/core';

export const TopBarActions: React.FC<{
	isLoading: boolean;
	onDownload: () => void;
	onRefresh: () => void;
}> = ({ isLoading, onDownload, onRefresh }) => (
	<Box
		style={{
			display: 'flex',
			alignItems: 'center',
			marginLeft: 'auto',
			gap: '8px',
		}}
	>
		<div key="export-csv">
			<Tooltip title="Export CSV">
				<span>
					<IconButton disabled={isLoading} onClick={onDownload}>
						<Download
							sx={{
								width: '24px !important',
								height: '24px !important',
							}}
						/>
					</IconButton>
				</span>
			</Tooltip>
		</div>
		<div key="refresh">
			<Tooltip title="Refresh">
				<span>
					<IconButton disabled={isLoading} onClick={onRefresh}>
						<Refresh
							sx={{
								width: '24px !important',
								height: '24px !important',
							}}
						/>
					</IconButton>
				</span>
			</Tooltip>
		</div>
	</Box>
);
